import { constructFrom as g } from "./constructFrom.js";
import { startOfWeek as D } from "./startOfWeek.js";
import { toDate as C } from "./toDate.js";
import { getDefaultOptions as F } from "./_lib/defaultOptions.js";
function d(r, e) {
  var l, o, c, m, u, k, W, Y;
  const a = C(r), t = a.getFullYear(), i = F(), n = (Y = (W = (m = (c = e == null ? void 0 : e.firstWeekContainsDate) != null ? c : (o = (l = e == null ? void 0 : e.locale) == null ? void 0 : l.options) == null ? void 0 : o.firstWeekContainsDate) != null ? m : i.firstWeekContainsDate) != null ? W : (k = (u = i.locale) == null ? void 0 : u.options) == null ? void 0 : k.firstWeekContainsDate) != null ? Y : 1, s = g(r, 0);
  s.setFullYear(t + 1, 0, n), s.setHours(0, 0, 0, 0);
  const O = D(s, e), f = g(r, 0);
  f.setFullYear(t, 0, n), f.setHours(0, 0, 0, 0);
  const T = D(f, e);
  return a.getTime() >= O.getTime() ? t + 1 : a.getTime() >= T.getTime() ? t : t - 1;
}
export {
  d as default,
  d as getWeekYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getWeekYear.js
// module id = 428
// module chunks = 41